<div class="title">{{ title }}</div>
<div class="typo-h4 py-0.5">
    <ng-content />
</div>
